"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    PAY_GRADES: function() {
        return PAY_GRADES;
    },
    shows: function() {
        return shows;
    }
});
const PAY_GRADES = {
    STREAM: {
        cost: 1000,
        income: 100000,
        avgTicketPrice: 0,
        avgMerchPrice: 10,
        avgViewers: 100000,
        avgAttendance: 100
    },
    CABLE: {
        cost: 10000,
        income: 500000,
        avgTicketPrice: 60,
        avgMerchPrice: 30,
        avgViewers: 200000,
        avgAttendance: 2000
    },
    TV: {
        cost: 100000,
        income: 100000,
        avgTicketPrice: 70,
        avgMerchPrice: 50,
        avgViewers: 2500000,
        avgAttendance: 15000
    },
    PPV: {
        cost: 1000000,
        income: 2000000,
        avgTicketPrice: 150,
        avgMerchPrice: 50,
        avgViewers: 250000,
        avgAttendance: 30000
    },
    MAJOR_PPV: {
        cost: 5000000,
        income: 5000000,
        avgTicketPrice: 450,
        avgMerchPrice: 100,
        avgViewers: 5000000,
        avgAttendance: 75000
    },
    WORLD: {
        cost: 10000000,
        income: 10000000,
        avgTicketPrice: 260,
        avgMerchPrice: 80,
        avgViewers: 4000000,
        avgAttendance: 80000
    }
};
const shows = [
    {
        id: "raw",
        name: "Raw",
        brandIds: [
            "raw"
        ],
        // frequency
        frequency: "weekly",
        weekIndex: false,
        monthIndex: false,
        dayIndex: 1,
        special: false,
        // points
        minPoints: 10,
        maxPoints: 100,
        maxDuration: 60 * 60 * 2.3,
        ...PAY_GRADES.TV,
        avgViewers: 1600000,
        cardImage: "//images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/f/6bed05fb-8ffb-4996-8575-1b9c179251cf/dfaqz4b-e7b319fd-5cf5-4ae1-8a2c-77f575e6674d.png/v1/fill/w_1280,h_720,q_80,strp/raw_2018_19_match_card_background_by_mackdanger1000000000_dfaqz4b-fullview.jpg?token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ1cm46YXBwOjdlMGQxODg5ODIyNjQzNzNhNWYwZDQxNWVhMGQyNmUwIiwiaXNzIjoidXJuOmFwcDo3ZTBkMTg4OTgyMjY0MzczYTVmMGQ0MTVlYTBkMjZlMCIsIm9iaiI6W1t7ImhlaWdodCI6Ijw9NzIwIiwicGF0aCI6IlwvZlwvNmJlZDA1ZmItOGZmYi00OTk2LTg1NzUtMWI5YzE3OTI1MWNmXC9kZmFxejRiLWU3YjMxOWZkLTVjZjUtNGFlMS04YTJjLTc3ZjU3NWU2Njc0ZC5wbmciLCJ3aWR0aCI6Ijw9MTI4MCJ9XV0sImF1ZCI6WyJ1cm46c2VydmljZTppbWFnZS5vcGVyYXRpb25zIl19.n08AbuygptcgfLnrcv-nkE9dQBwywY8W0_Y1c66Yb0Q",
        image: "//www.wwe.com/f/styles/wwe_show_logo_l/public/all/2022/06/RAW-Logo--7d5dc4d69611241d54973979bdae1d32.png",
        color: "#fff",
        backgroundColor: "#7b1721"
    },
    {
        id: "smackdown",
        name: "Smackdown",
        brandIds: [
            "smackdown"
        ],
        entranceVideoUrl: "BdtRl-9-Yzk",
        // frequency
        frequency: "weekly",
        weekIndex: false,
        monthIndex: false,
        dayIndex: 5,
        avgViewers: 2200000,
        special: false,
        // points
        minPoints: 10,
        maxDuration: 60 * 60 * 1.5,
        maxPoints: 100,
        ...PAY_GRADES.TV,
        cardImage: "//www.wwe.com/f/styles/talent_champion_xl/public/all/2020/04/WWEBackdrops_SDrev--eb5a9531565a08f16c261d118855a274.jpg",
        image: "//www.wwe.com/f/styles/wwe_show_logo_l/public/all/2019/10/SmackDown_2019_Vert_White--dfb28435b27ecf12e75406176c168c6a.png",
        color: "#fff",
        backgroundColor: "#0a3766"
    },
    {
        id: "njpw",
        name: "NJPW",
        brandIds: [
            "njpw"
        ],
        weekly: true,
        monthly: false,
        yearly: false,
        dayOfWeekIndex: 5,
        minPoints: 10,
        maxPoints: 100,
        maxDuration: 60 * 60 * 1,
        ...PAY_GRADES.TV,
        avgViewers: 700000,
        special: false,
        image: "//www.njpw1972.com/wp-content/themes/njpw-en/images/logo_01.png",
        color: "#fff",
        backgroundColor: "#000"
    },
    {
        id: "nxt",
        name: "NXT",
        brandIds: [
            "nxt"
        ],
        weekly: true,
        entranceVideoUrl: "z3JqIYqWOyk",
        // frequency
        frequency: "weekly",
        weekIndex: false,
        monthIndex: false,
        dayIndex: 2,
        maxDuration: 60 * 60 * 1.5,
        special: false,
        // points
        minPoints: 10,
        maxPoints: 90,
        ...PAY_GRADES.CABLE,
        avgViewers: 700000,
        cardImage: "//www.wwe.com/f/styles/talent_champion_xl/public/all/2020/04/WWEBackdrops_NXTgrphc--a6d0456b343e800174f3dc72ed0790fd.jpg",
        image: "//www.wwe.com/f/styles/wwe_show_logo_sm/public/all/2022/09/NXT_NewLogo--61a7c04575fabf96fb577dcdfc0bde63.png",
        color: "#fff",
        backgroundColor: "#999"
    },
    {
        id: "dynamite",
        name: "Dynamite",
        brandIds: [
            "dynamite"
        ],
        entranceVideoUrl: "6yhctxe8DKo",
        // frequency
        frequency: "weekly",
        maxDuration: 60 * 60 * 1.5,
        weekIndex: false,
        monthIndex: false,
        dayIndex: 3,
        special: false,
        // points
        minPoints: 10,
        maxPoints: 100,
        ...PAY_GRADES.TV,
        avgViewers: 800000,
        image: "//upload.wikimedia.org/wikipedia/en/1/1f/AEW_Dynamite_logo.jpg",
        color: "#fff",
        backgroundColor: "#562a3b"
    },
    {
        id: "rampage",
        name: "Rampage",
        brandIds: [
            "dynamite",
            "collision"
        ],
        entranceVideoUrl: "AifaPkNzPv8",
        // frequency
        frequency: "weekly",
        maxDuration: 60 * 60 * 1,
        weekIndex: false,
        monthIndex: false,
        dayIndex: 5,
        special: false,
        // points
        minPoints: 10,
        maxPoints: 80,
        ...PAY_GRADES.CABLE,
        avgViewers: 400000,
        image: "//upload.wikimedia.org/wikipedia/en/c/c2/AEW_Rampage_Logo.jpg",
        color: "#f8eabb",
        backgroundColor: "#1c1817"
    },
    {
        id: "collision",
        name: "Collision",
        brandIds: [
            "collision"
        ],
        image: "//static.wixstatic.com/media/815952_038c632668da4f0d955dda0158053d44~mv2.png/v1/fill/w_224,h_82,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/aewlogo24.png",
        // frequency
        frequency: "weekly",
        weekIndex: false,
        monthIndex: false,
        dayIndex: 6,
        special: false,
        // points
        minPoints: 10,
        maxPoints: 100,
        ...PAY_GRADES.CABLE,
        avgViewers: 400000,
        color: "#f8eabb",
        backgroundColor: "#1c1817"
    },
    {
        id: "main-event",
        name: "Main Event",
        brandIds: [
            "raw",
            "smackdown"
        ],
        entranceVideoUrl: "Aacb1NYeKGk",
        // frequency
        frequency: "weekly",
        weekIndex: false,
        monthIndex: false,
        dayIndex: 6,
        special: false,
        maxDuration: 60 * 60 * 1.1,
        // points
        minPoints: 10,
        maxPoints: 80,
        ...PAY_GRADES.CABLE,
        avgViewers: 100000,
        image: "//upload.wikimedia.org/wikipedia/en/6/6f/MainEvent2014.png",
        color: "#fff",
        backgroundColor: "#1a1458"
    },
    {
        id: "roh",
        name: "Ring Of Honor",
        brandIds: [
            "roh"
        ],
        color: "#000",
        backgroundColor: "#fff",
        avgViewers: 100000,
        maxDuration: 60 * 60 * 1.5,
        // frequency
        frequency: "weekly",
        weekIndex: false,
        monthIndex: false,
        dayIndex: 3,
        special: false,
        // points
        minPoints: 10,
        maxPoints: 100,
        ...PAY_GRADES.STREAM
    },
    {
        id: "lvl-up",
        name: "Lvl up",
        brandIds: [
            "nxt"
        ],
        // frequency
        frequency: "weekly",
        maxDuration: 60 * 60 * 1,
        weekIndex: false,
        monthIndex: false,
        dayIndex: 4,
        special: false,
        // points
        minPoints: 10,
        maxPoints: 70,
        ...PAY_GRADES.STREAM,
        avgViewers: 100000,
        image: "//www.wwe.com/f/styles/wwe_show_logo_l/public/all/2022/02/NXT_LEVEL_UP_LOGO_(1)--6ca087c3eae084b786505cd6e61351b8.png",
        color: "#f8f9f9",
        cardImage: "//www.wwe.com/f/styles/shows_hub_premier_hero/public/all/2017/10/Show_Sub_Header--9423c0273883caec125b3644bfc405a0.jpg",
        backgroundColor: "#268941"
    },
    {
        id: "intro",
        name: "Nitro",
        brandIds: [
            "wcw"
        ],
        entranceVideoUrl: "WVo7yVG6Af0",
        // frequency
        frequency: "weekly",
        weekIndex: false,
        monthIndex: false,
        maxDuration: 60 * 60 * 2,
        dayIndex: 1,
        special: false,
        // points
        minPoints: 10,
        maxPoints: 100,
        ...PAY_GRADES.TV,
        color: "#fff",
        backgroundColor: "#000",
        avgViewers: 4000000,
        image: "//static.wwe9.com/shain/v1/dataservice/ResizeImage/$value?ImageId=%278899370%27&EntityType=%27Item%27&EntityId=%271009%27&Width=337&Height=190&ImageUrl=%278899370.jpg"
    },
    {
        id: "tna",
        name: "TNA Wrestling",
        brandIds: [
            "tna"
        ],
        frequency: "weekly",
        weekIndex: false,
        monthIndex: false,
        dayIndex: 4,
        special: false,
        minPoints: 50,
        maxPoints: 90,
        maxDuration: 60 * 60 * 1,
        ...PAY_GRADES.TV,
        avgViewers: 1000000,
        image: "//impactwrestling.com/wp-content/uploads/2023/12/TNA-Logo-App-Icon-square-16x9@4x-768x432.jpg",
        color: "#fff",
        backgroundColor: "#201515"
    },
    {
        id: "thunder",
        name: "Thunder",
        brandIds: [
            "wcw"
        ],
        // frequency
        frequency: "weekly",
        weekIndex: false,
        monthIndex: false,
        dayIndex: 4,
        special: false,
        // points
        minPoints: 20,
        maxDuration: 60 * 60 * 1,
        maxPoints: 90,
        color: "#fff",
        backgroundColor: "#000",
        ...PAY_GRADES.CABLE,
        image: "//static.wwe9.com/shain/v1/dataservice/ResizeImage/$value?ImageId=%278900995%27&EntityType=%27Item%27&EntityId=%275125%27&Width=337&Height=190&ImageUrl=%278900995.jpg"
    },
    {
        id: "ecw-tv",
        name: "ECW TV",
        brandIds: [
            "ecw"
        ],
        // frequency
        frequency: "weekly",
        weekIndex: false,
        monthIndex: false,
        dayIndex: 2,
        special: false,
        // points
        minPoints: 20,
        maxPoints: 90,
        maxDuration: 60 * 60 * 1,
        ...PAY_GRADES.CABLE,
        color: "#fff",
        backgroundColor: "#000",
        image: "//www.wwe.com/f/styles/wwe_show_logo_l/public/2016/03/ECW--618ee2651cb1c769e50855fd47255361.png"
    },
    {
        id: "rumble",
        name: "Rumble",
        ...PAY_GRADES.MAJOR_PPV,
        image: "//www.wwe.com/f/styles/wwe_show_logo_network_l/public/all/2021/01/RoyalRumble_2021_logo--9e96db178bc33871f47fd62860de17a9.png",
        backgroundColor: "#666",
        brandIds: [
            "raw",
            "smackdown"
        ],
        color: "#fff",
        // frequency
        frequency: "yearly",
        maxDuration: 60 * 60 * 4,
        weekIndex: 4,
        monthIndex: 0,
        dayIndex: 6,
        special: true,
        // points
        minPoints: 0,
        maxPoints: 100
    },
    {
        id: "Wrestlemania-night-1",
        name: "Wrestlemania Night 1",
        image: "//www.wwe.com/f/styles/wwe_show_logo_xl/public/all/2024/02/WrestleMania_40_Primary_Logo_Black_Background--8ad98c026d72b44c42753d8e0ed18261.png",
        backgroundColor: "#081f2a",
        brandIds: [
            "raw",
            "smackdown"
        ],
        color: "#fff",
        special: true,
        // frequency
        frequency: "yearly",
        maxDuration: 60 * 60 * 5,
        weekIndex: 0,
        monthIndex: 3,
        dayIndex: 6,
        // points
        minPoints: 0,
        maxPoints: 100,
        ...PAY_GRADES.WORLD
    },
    {
        id: "Wrestlemania-night-2",
        name: "Wrestlemania Night 2",
        image: "//www.wwe.com/f/styles/wwe_show_logo_xl/public/all/2024/02/WrestleMania_40_Primary_Logo_Black_Background--8ad98c026d72b44c42753d8e0ed18261.png",
        backgroundColor: "#081f2a",
        brandIds: [
            "raw",
            "smackdown"
        ],
        color: "#fff",
        special: true,
        // frequency
        frequency: "yearly",
        maxDuration: 60 * 60 * 5,
        weekIndex: 1,
        monthIndex: 3,
        dayIndex: 0,
        // points
        minPoints: 0,
        maxPoints: 100,
        ...PAY_GRADES.WORLD
    },
    {
        id: "summerslam",
        name: "Slam",
        image: "//www.wwe.com/f/styles/wwe_show_logo_network_l/public/2016/02/SummerSlam_0--0aefb0a6de381283e9bb6b5d62d62f25.png",
        backgroundColor: "#d36800",
        brandIds: [
            "raw",
            "smackdown"
        ],
        color: "#fff",
        // frequency
        frequency: "yearly",
        maxDuration: 60 * 60 * 4,
        weekIndex: 0,
        monthIndex: 7,
        dayIndex: 6,
        // points
        minPoints: 0,
        maxPoints: 100,
        ...PAY_GRADES.MAJOR_PPV
    },
    {
        id: "survivor-series",
        name: "Survivor Series",
        image: "//www.wwe.com/f/styles/wwe_show_logo_network_l/public/all/2022/09/Survivor_Series_WarGames_Logo--de9f90df7af3d7f8a544af43659217ca.png",
        backgroundColor: "#000000",
        brandIds: [
            "raw",
            "smackdown"
        ],
        maxDuration: 60 * 60 * 4,
        color: "#fff",
        weekly: true,
        monthly: false,
        yearly: true,
        special: true,
        frequency: "yearly",
        weekIndex: 3,
        monthIndex: 10,
        dayIndex: 6,
        // points
        minPoints: 0,
        maxPoints: 100,
        ...PAY_GRADES.MAJOR_PPV
    },
    {
        id: "night-of-champions",
        name: "Night of Champions",
        image: "//www.wwe.com/f/styles/wwe_show_logo_l/public/all/2019/08/Clash_Of_Champions--a1dee26596770dec4560cb1aa8dfc79d.png",
        backgroundColor: "#000",
        brandIds: [
            "raw",
            "smackdown"
        ],
        maxDuration: 60 * 60 * 4,
        color: "#fff",
        // frequency
        frequency: "yearly",
        weekIndex: 3,
        dayIndex: 6,
        monthIndex: 4,
        special: true,
        // points
        minPoints: 0,
        maxPoints: 100,
        ...PAY_GRADES.PPV
    },
    {
        name: "Backlash",
        image: "//www.wwe.com/f/styles/wwe_show_logo_l/public/all/2020/05/Backlash_2020--47718e27094f9556493a97f953c037b6.png",
        backgroundColor: "#232828",
        brandIds: [
            "raw",
            "smackdown"
        ],
        maxDuration: 60 * 60 * 3,
        color: "#fff",
        // frequency
        frequency: "yearly",
        weekIndex: 0,
        monthIndex: 4,
        dayIndex: 6,
        special: true,
        // points
        minPoints: 0,
        maxPoints: 100,
        ...PAY_GRADES.PPV,
        id: "backlash"
    },
    {
        id: "chamber",
        name: "Chamber",
        image: "//www.wwe.com/f/styles/wwe_show_logo_xl/public/all/2024/02/Elimination_Chamber_Perth_SECONDARY_PURPLE_Logo_Black_Background--d00bd381be065261b11790726544d503.png",
        backgroundColor: "#000000",
        brandIds: [
            "raw",
            "smackdown"
        ],
        maxDuration: 60 * 60 * 3,
        color: "#bd0000",
        // frequency
        frequency: "yearly",
        weekIndex: 3,
        monthIndex: 1,
        dayIndex: 6,
        special: true,
        // points
        minPoints: 0,
        maxPoints: 100,
        ...PAY_GRADES.PPV
    },
    {
        id: "mitb",
        name: "MITB",
        image: "//www.wwe.com/f/styles/wwe_show_logo_network_l/public/all/2018/06/20180608_MITB_2018_Logo--7c8ce12e113e0c49b7e8dbae32c388e4.png",
        backgroundColor: "#01652f",
        brandIds: [
            "raw",
            "smackdown"
        ],
        color: "#fff",
        // frequency
        frequency: "yearly",
        maxDuration: 60 * 60 * 3,
        weekIndex: 1,
        monthIndex: 6,
        dayIndex: 6,
        special: true,
        // points
        minPoints: 0,
        maxPoints: 100,
        cardImage: "//www.wwe.com/f/styles/talent_champion_xl/public/all/2020/04/WWEBackdrops_InRingMITB--521f0f60f5e2b87551c752bd567ded24.jpg",
        ...PAY_GRADES.PPV
    },
    {
        id: "extreme-rules",
        name: "Extreme Rules",
        image: "//www.wwe.com/f/styles/wwe_show_logo_network_l/public/all/2021/09/EXRULES_Logo--d896ac514d238f9b5e82688f73785abc.png",
        backgroundColor: "#5439ac",
        brandIds: [
            "raw",
            "smackdown"
        ],
        color: "#56dd01",
        // frequency
        frequency: "yearly",
        weekIndex: 3,
        monthIndex: 11,
        maxDuration: 60 * 60 * 3,
        dayIndex: 0,
        special: true,
        // points
        minPoints: 0,
        maxPoints: 100,
        ...PAY_GRADES.PPV
    },
    {
        name: "Showdown",
        image: "//www.wwe.com/f/styles/wwe_show_logo_network_l/public/all/2019/05/SuperShowDown_2019--1dc958321b4ae7ba3caf2944e6b9c3af.png",
        backgroundColor: "#370037",
        color: "#fff",
        brandIds: [
            "raw",
            "smackdown"
        ],
        // frequency
        frequency: "yearly",
        weekIndex: 2,
        monthIndex: 6,
        maxDuration: 60 * 60 * 4,
        dayIndex: 0,
        special: true,
        // points
        minPoints: 0,
        maxPoints: 100,
        ...PAY_GRADES.WORLD,
        id: "super-showdown"
    },
    // {
    //   name: 'Hell',
    //   image:
    //     '//www.wwe.com/f/styles/wwe_show_logo_network_l/public/all/2020/10/HellInACell2020--0f11badb29f43c5c202a81d10f8f7b91.png',
    //     brandIds: ['raw', 'smackdown'],
    //   backgroundColor: '#000000',
    //   color: '#fff',
    //   // frequency
    //   frequency: 'yearly',
    //   weekIndex: 1,
    //   monthIndex: 7,
    //   dayIndex: 0,
    //   special: true,
    //   // points
    //   minPoints: 0,
    //   maxPoints: 100,
    //   ...PAY_GRADES.PPV,
    //   id: 'hell-in-a-cell'
    // },
    {
        id: "crown-jewel",
        name: "Jewel",
        image: "//www.wwe.com/f/styles/wwe_show_logo_network_l/public/all/2019/10/CrownJewel_Logo_Standard--f25e9635ce4b5941c266074f863546ba.png",
        backgroundColor: "#000000",
        brandIds: [
            "raw",
            "smackdown"
        ],
        color: "#beffb3",
        // frequency
        maxDuration: 60 * 60 * 4,
        frequency: "yearly",
        weekIndex: 0,
        monthIndex: 10,
        dayIndex: 0,
        special: true,
        // points
        minPoints: 0,
        maxPoints: 100,
        ...PAY_GRADES.WORLD
    },
    {
        id: "nxt-vengeance-day",
        name: "NXT Vengeance Day",
        brandIds: [
            "nxt"
        ],
        backgroundColor: "#000000",
        maxDuration: 60 * 60 * 2,
        color: "#fff",
        // frequency
        frequency: "yearly",
        weekIndex: 1,
        monthIndex: 1,
        dayIndex: 6,
        special: true,
        // points
        minPoints: 0,
        maxPoints: 100,
        ...PAY_GRADES.WORLD
    },
    {
        name: "Saturday Night's Main Event",
        image: "//www.wwe.com/f/styles/wwe_show_logo_l/public/2016/02/SaturdayNightMainEvent--c9ee4efa39a9371cbd7703018a4f8bd7.png",
        backgroundColor: "#000000",
        color: "#fff",
        brandIds: [
            "hall-of-fame"
        ],
        // frequency
        maxDuration: 60 * 60 * 1,
        frequency: "weekly",
        weekIndex: false,
        monthIndex: false,
        dayIndex: 6,
        special: true,
        // points
        minPoints: 0,
        maxPoints: 100,
        ...PAY_GRADES.TV,
        id: "snme"
    },
    {
        id: "double-or-nothing",
        name: "Double or nothing",
        maxDuration: 60 * 60 * 4,
        backgroundColor: "#000",
        color: "#fff",
        brandIds: [
            "dynamite"
        ],
        // frequency
        frequency: "yearly",
        weekIndex: 4,
        monthIndex: 4,
        dayIndex: 6,
        special: true,
        // points
        minPoints: 50,
        maxPoints: 100,
        ...PAY_GRADES.WORLD
    },
    {
        id: "forbidden-door",
        name: "Forbidden Door",
        backgroundColor: "#000",
        maxDuration: 60 * 60 * 4,
        color: "#fff",
        brandIds: [
            "dynamite"
        ],
        // frequency
        frequency: "yearly",
        dayIndex: 6,
        monthIndex: 5,
        weekIndex: 4,
        special: true,
        // points
        minPoints: 50,
        maxPoints: 100,
        ...PAY_GRADES.WORLD
    },
    {
        id: "all-in",
        name: "All In",
        backgroundColor: "#000",
        maxDuration: 60 * 60 * 4,
        color: "#fff",
        brandIds: [
            "dynamite"
        ],
        // frequency
        frequency: "yearly",
        dayIndex: 6,
        monthIndex: 6,
        weekIndex: 4,
        special: true,
        // points
        minPoints: 50,
        maxPoints: 100,
        ...PAY_GRADES.WORLD
    },
    {
        id: "all-out",
        name: "All Out",
        backgroundColor: "#000",
        maxDuration: 60 * 60 * 3,
        color: "#fff",
        brandIds: [
            "dynamite"
        ],
        // frequency
        frequency: "yearly",
        dayIndex: 6,
        monthIndex: 8,
        weekIndex: 1,
        special: true,
        // points
        minPoints: 0,
        maxPoints: 100,
        ...PAY_GRADES.WORLD
    }
];
